<template>
    <span v-if="hasTestAgency" :class="`${isConnectDisabled ? 'ai-premium-lock-image' : 'ai-premium-image'}`">
        <button
            type="button"
            :class="`btn btn-md btn-save-notify ms-2 ${buttonClasses}`"
            :disabled="isConnectDisabled"
            @click="saveVisit()"
        >
            {{ buttonName }}
            <span v-if="isConnectDisabled" class="lock-icon"></span>
        </button>
    </span>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "pinia";
import { useApp } from "../../../pages-vue/App/useApp";
import { Container } from "aurelia-dependency-injection";
import { AxxessIntelligenceService } from "../../../services/axxess-intelligence.service";
import { helperTestingAgency } from "../../../common/vue-helpers/testing-agency-check";

export default defineComponent({
    emits: ["handleSaveVisit"],
    props: {
        agencyId: {
            type: String,
            default: ""
        },
        buttonClasses: {
            type: String,
            default: ""
        },
        infoClasses: {
            type: String,
            default: ""
        },
        buttonName: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            _axxessIntelligenceService: null,
            canShowPremium: false,
            hasTestAgency: false
        };
    },

    async created() {
        this.hasTestAgency = await helperTestingAgency.checkHasTestingAgency();
        if (!this.hasTestAgency) {
            return;
        }
        this._axxessIntelligenceService = Container.instance.get(AxxessIntelligenceService);
        const isPremiumResp = await this._axxessIntelligenceService.getAiPermissionByAgencies({
            AgencyIds: [this.agencyId]
        });
        this.canShowPremium = isPremiumResp ? isPremiumResp.IsPremium : false;
    },

    computed: {
        ...mapState(useApp, ["hasAxxessConnectPermission"]),

        isConnectDisabled() {
            return !this.canShowPremium || !this.hasAxxessConnectPermission;
        }
    },
    methods: {
        saveVisit() {
            this.$emit("handleSaveVisit");
        }
    }
});
</script>

<style scoped>
.btn-save-notify {
    color: black;
    border: 2px solid transparent;
    border-radius: 0.25rem;
    background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(90deg, #23d4c5, #ad1a38, #9c27b0);
    background-origin: border-box;
    background-clip: padding-box, border-box;
}

.btn-save-notify:hover,
.btn-save-notify:focus {
    color: black;
    background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(90deg, #23d4c5, #ad1a38, #9c27b0);
}

.lock-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: 6px;
    vertical-align: text-bottom;
    background-color: currentColor;
    -webkit-mask: url("../../../assets/images/lock.svg") no-repeat center / contain;
    mask: url("../../../assets/images/lock.svg") no-repeat center / contain;
}
</style>
